// extracted by mini-css-extract-plugin
export default {"dotSpinner":"Loader_dotSpinner__zxddE","background":"Loader_background__1hCmc","dotSpinnerDot":"Loader_dotSpinnerDot__YD3aL","pulse0112":"Loader_pulse0112__6FXUg"};